import { useContext } from 'react';
import { OnlineContext, type OnlineContextValue } from '@/contexts/OnlineContext';

/**
 * Access the online/offline context.
 *
 * Provides: isOnline, syncStatus, pendingCount, lastSyncAt, forceSync.
 */
export function useOnline(): OnlineContextValue {
  const ctx = useContext(OnlineContext);
  if (!ctx) {
    throw new Error(
      'useOnline deve essere usato all\'interno di <OnlineProvider>',
    );
  }
  return ctx;
}
